<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              Exibindo 2 Produtos (Total de 2)
            </span>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">
              Acompanhe em tempo real todos os produtos cadastrados pelo seu estabelecimento
            </span>
          </h3>
          <div class="card-toolbar">
            <div class="input-icon h-40px">
              <input
                type="text"
                class="form-control form-control-lg form-control-solid h-40px"
                v-model="buscar"
                placeholder="Buscar..."
              />
              <span>
                <span class="svg-icon svg-icon-lg">
                  <!--begin::Svg Icon-->
                  <inline-svg src="media/svg/icons/General/Search.svg" />
                  <!--end::Svg Icon-->
                </span>
              </span>
            </div>
          </div>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div
          @scroll="handleScroll"
          class="card-body pt-2 pb-0"
          style="max-height: 418px; overflow-y: auto; overflow-x: auto"
        >
          <!--begin::Table-->
          <div class="table-responsive" style="overflow-x: initial">
            <b-table striped hover :items="items" :fields="fields">
            </b-table>
          </div>
          <!--end::Table-->
        </div>
        <!--end::Body-->
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";

export default {
  name: "Produtos",
  data() {
    return {
      buscar: "",
      items: [
        {
          CODIGO: '1',
          DESCRICAO: 'Agulha',
          MARCA: 'JOHNSON',
          CATEGORIA: '001',
          CATEGORIA_DESCRICAO: 'Material Cirúrgico',
          CODIGO_BARRA: '123456789123456789'
        },
        {
          CODIGO: '2',
          DESCRICAO: 'Caneta',
          MARCA: 'BIC',
          CATEGORIA: '002',
          CATEGORIA_DESCRICAO: 'Material Escritório',
          CODIGO_BARRA: '123456789123456780'
        }
      ],
      fields: [
        {
          key: 'CODIGO',
          label: 'Código',
          sortable: true
        },
        {
          key: 'DESCRICAO',
          label: 'Descrição',
          sortable: true
        },
        {
          key: 'MARCA',
          label: 'Marca',
          sortable: true
        },
        {
          key: 'CATEGORIA',
          label: 'Categoria',
          sortable: true
        },
        {
          key: 'CATEGORIA_DESCRICAO',
          label: 'Descrição Categoria',
          sortable: true
        },
        {
          key: 'CODIGO_BARRA',
          label: 'Código de Barras',
          sortable: true
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Cadastros", route: "produtos" },
      { title: "Produtos" }
    ]);
  },
  computed: {
    ...mapGetters(["verificado", "fgModoPR"])
  },
  methods: {
    handleScroll() {

    }
  }
};
</script>
